/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { TitleAgentInboxContainer } from '../TitleAgentInbox';
import { ThreadDetailsContainer } from '../ThreadDetails';
import type { ReduxProps } from './InboxContainer';
import { AlertBar } from '@blend/enterprise-components';
import { isEmpty, map, entries } from 'lodash';
import { InboxContext, InboxContextType } from './InboxContext';
import { useEffect } from 'react';

const styles = StyleSheet.create({
  errorWrapper: {
    marginBottom: 16,
  },
  inboxWrapper: {
    maxWidth: 900,
  },
});

export interface InboxProps {
  stylingConfig?: InboxContextType['stylingConfig'];
}

export const Inbox: React.FC<InboxProps & ReduxProps> = ({
  errors,
  selectedThread,
  removeSelectedThread,
  stylingConfig = {},
}) => {
  const contextValue = { stylingConfig };

  useEffect(() => {
    removeSelectedThread();
  }, []);

  return (
    <InboxContext.Provider value={contextValue}>
      <div className={css(styles.inboxWrapper)} data-it="SharedInboxWrapper">
        {!isEmpty(errors) &&
          map(entries(errors), ([key, error]) => {
            return (
              <div className={css(styles.errorWrapper)} key={`alertBar-${key}`}>
                <AlertBar message={error} theme="error" />
              </div>
            );
          })}

        {selectedThread ? <ThreadDetailsContainer /> : <TitleAgentInboxContainer />}
      </div>
    </InboxContext.Provider>
  );
};
